import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import "./App.css"
import Home from './components/Home/Home';
import Loader from './components/Loader/Loader';
import Login from './components/Login/Login';
import NotFound from './components/NotFound/NotFound';
import Register from './components/Register/Register';
const App = () => {
  const [user, setuser] = useState({isAuthenticated:false});
  const [loading, setloading] = useState(true);
  useEffect(()=>{
    const fetchuserData = async()=>{
      try{
        setloading(true)
        const {data} = await axios.get("/api/me",{withCredentials:true});
        setuser({data,isAuthenticated:true});
        setloading(false)
      }
      catch(err){
        setloading(false)
        if(err) 
        {
          console.log(err.response.data.msg)
        }
      }
    }
    fetchuserData()
  },[]);
  if(loading) return <Loader/>
  return (
    <BrowserRouter>
    <Routes>
      <Route path='/' index element={ user.isAuthenticated ? <Home setuser={setuser}/> : <Navigate to={'/login'}/>}/>
      <Route path='/login'  element={ user.isAuthenticated ? <Navigate to={'/'} /> : <Login setuser={setuser} />}/>
      <Route path='/register'  element={ user.isAuthenticated ? <Navigate to={'/'} /> : <Register setuser={setuser}/>}/>
      <Route path='*'  element={<NotFound/>}/>
    </Routes>
    </BrowserRouter>
  )
}

export default App